import { render, staticRenderFns } from "./AdminReviewTab.vue?vue&type=template&id=f92472ce&scoped=true"
import script from "./AdminReviewTab.vue?vue&type=script&lang=js"
export * from "./AdminReviewTab.vue?vue&type=script&lang=js"
import style0 from "./AdminReviewTab.vue?vue&type=style&index=0&id=f92472ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92472ce",
  null
  
)

export default component.exports